import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=e8b3f7b0&scoped=true"
import script from "./formItem.vue?vue&type=script&lang=js"
export * from "./formItem.vue?vue&type=script&lang=js"
import style0 from "./formItem.vue?vue&type=style&index=0&id=e8b3f7b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b3f7b0",
  null
  
)

export default component.exports